module.exports = __webpack_public_path__ + "static/media/27.d0e50200.mp3";